var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.667 8.333h3.97a1.667 1.667 0 0 1 1.49 2.412l-2.916 5.834c-.283.564-.86.921-1.491.921H9.372c-.136 0-.272-.017-.404-.05l-3.135-.783m5.834-8.334V4.167c0-.92-.746-1.667-1.667-1.667h-.08a.754.754 0 0 0-.753.754c0 .595-.177 1.177-.507 1.672l-2.827 4.24v7.5m5.834-8.333H10m-4.167 8.334H4.167c-.92 0-1.667-.747-1.667-1.667v-5c0-.92.746-1.667 1.667-1.667H6.25"
  })));
};
export default SvgThumbsUp;